import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import OfferView from "../views/OfferView.vue";
import PricingView from "../views/PricingView.vue";
import ContactView from "../views/ContactView.vue";
import ClientAreaView from "../views/ClientAreaView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "Strona główna" },
  },
  {
    path: "/oferta",
    name: "offer",
    component: OfferView,
    meta: { title: "Oferta" },
  },
  {
    path: "/cennik",
    name: "pricing",
    component: PricingView,
    meta: { title: "Cennik" },
  },
  {
    path: "/kontakt",
    name: "contact",
    component: ContactView,
    meta: { title: "Kontakt" },
  },
  {
    path: "/strefa-klienta",
    name: "client-area",
    component: ClientAreaView,
    meta: { title: "Strefa klienta" },
  },
  {
    path: "/o-nas",
    name: "about",
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
    meta: { title: "O nas" },
  },
  {
    path: "/zespol",
    name: "team",
    component: () => import(/* webpackChunkName: "team" */ "../views/TeamView.vue"),
    meta: { title: "Zespół" },
  },
  // Dodanie przekierowania dla nieistniejących ścieżek
  {
    path: "/:pathMatch(.*)*",
    redirect: "/",
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Dynamiczna zmiana tytułu strony
router.beforeEach((to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} | Selam` : "Selam";
  next();
});

export default router;
